import { difference, includes, map, max } from 'lodash/fp';
import { FormikField, Tooltip } from '@ahmdigital/ui';
import React from 'react';

import { EXCESS_TYPES } from '../../../../../../ahm-constants/ui';
import { ExcessToggleValues } from '../../../../../../selectors/select-excess-toggle-values';
import { IsExcessToggleApplicableType } from '../../../../../../selectors/select-is-excess-toggle-applicable';

const hospitalExcessToOptions = (hospitalExcess: ExcessToggleValues) => {
  const excessForOptions = EXCESS_TYPES;
  const unavailableExcessTypes = difference(EXCESS_TYPES, hospitalExcess);

  return map((value) => {
    const isDisabled = includes(value, unavailableExcessTypes);
    return {
      isDisabled,
      text: `$${value}`,
      value: `${value}`,
    };
  })(excessForOptions);
};

type ExcessToggleProps = {
  hospitalExcess: ExcessToggleValues;
  isExcessApplicable: IsExcessToggleApplicableType;
  match?: {
    params?: {
      needsProductType?: string;
      needsType?: string;
    };
  };
};

const ExcessToggle = ({ isExcessApplicable, hospitalExcess }: ExcessToggleProps) => {
  if (!isExcessApplicable) {
    return null;
  }

  const tooltip = (
    <Tooltip>
      An excess is an upfront lump sum payment that you agree to pay towards the cost of your hospital stay or day
      surgery. You can reduce your health insurance premium by opting for a ${max(hospitalExcess)} hospital excess per
      {/* @ts-expect-error - Automatic, Please fix when editing this file */}
      person (up to a maximum of ${max(hospitalExcess) * 2} per couple/family per Membership Year).
    </Tooltip>
  );

  return (
    <FormikField
      label="I want my hospital excess to be"
      name="hospitalExcess"
      size="auto"
      inputVariant={['button', 'fullWidth']}
      type="dropdown"
      options={hospitalExcessToOptions(hospitalExcess)}
      tooltip={tooltip}
    />
  );
};

ExcessToggle.defaultProps = {
  match: null,
};

export default ExcessToggle;
